const API_URL = window.location.hostname === 'localhost' ? 'http://localhost:3000/' : 'https://api.ssm.casino/';

export const fetchTokens = async () => {
    try {
        const response = await fetch(API_URL+'api/token/list');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data['tokens'];
    } catch (error) {
        console.error('Error fetching tokens:', error);
        return [];
    }
};

export const fetchTokenDetails = async (mintAddress: string) => {
    try {
        const response = await fetch(`${API_URL}api/token/add`, { method: 'POST', body: JSON.stringify({ mintAddress }), headers: { 'Content-Type': 'application/json' } });
        const tokenDetails = await response.json();
        return tokenDetails;
    } catch (error) {
        console.error('Error fetching token details:', error);
        throw error;
    }
};